var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faCommentAlt } from "@fortawesome/pro-regular-svg-icons";
import { useAppSelector } from "@/hooks/store";
import { getCurrentUser } from "@/store/utils/selectors/userSelector";
import Input from "@mui/joy/Input";
import { useSaveRecordMutation } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useDeleteRecordsMutation } from "@/store/api";
import toast from "react-hot-toast";
import { MessageDisplay } from "./messageDisplay";
export var Activity = function (_a) {
    var record = _a.record;
    var activityString = record === null || record === void 0 ? void 0 : record.name;
    console.log("ACTIVITY RECORD ", record);
    var _b = useState(record === null || record === void 0 ? void 0 : record.id), recordId = _b[0], setRecordId = _b[1];
    var _c = useState(""), activityAuthor = _c[0], setActivityAuthor = _c[1];
    var _d = useState(""), activityName = _d[0], setActivityName = _d[1];
    var _e = useState(""), objectId = _e[0], setObjectId = _e[1];
    var _f = useState(""), objectModuleName = _f[0], setObjectModuleName = _f[1];
    var _g = useState(""), objectName = _g[0], setObjectName = _g[1];
    var currentUser = useAppSelector(getCurrentUser) || {};
    var _h = useState(), type = _h[0], setType = _h[1];
    var _j = useState(), linkUrl = _j[0], setLinkURL = _j[1];
    var navigate = useNavigate();
    useEffect(function () {
        setActivityAuthor(record === null || record === void 0 ? void 0 : record.created_by_name);
        var nameMatch = activityString.match(/\{SugarFeed.CREATED_(.*)\}/);
        setActivityName((nameMatch === null || nameMatch === void 0 ? void 0 : nameMatch[1]) ? nameMatch === null || nameMatch === void 0 ? void 0 : nameMatch[1].toLowerCase() : "");
        var objectMatch = activityString.match(/\[(.*)\]/);
        var object = (objectMatch === null || objectMatch === void 0 ? void 0 : objectMatch[1]) ? objectMatch === null || objectMatch === void 0 ? void 0 : objectMatch[1].split(":") : [];
        if (object.length === 3) {
            setObjectModuleName(object[0]);
            setObjectId(object[1]);
            setObjectName(object[2]);
        }
        setType(record === null || record === void 0 ? void 0 : record.link_type);
        setLinkURL(record === null || record === void 0 ? void 0 : record.link_url);
        (record === null || record === void 0 ? void 0 : record.related_module) === "UserFeed" ||
            (record === null || record === void 0 ? void 0 : record.related_module) === "SugarFeed"
            ? setIsUserFeedRecord(true)
            : setIsUserFeedRecord(false);
    }, []);
    var goToDetail = function () {
        navigate("/modules/".concat(objectModuleName, "/EditView/").concat(objectId));
    };
    var _k = useState(""), replyMsg = _k[0], setReplyMessage = _k[1];
    var handleTextChange = function (e) {
        var replyMessage = e.target.value;
        if (replyMessage) {
            setReplyMessage(replyMessage);
        }
        else if (replyMessage === "") {
            setReplyMessage("");
        }
    };
    var _l = useSaveRecordMutation(), saveRecordMutation = _l[0], isLoadingSave = _l[1].isLoading;
    var _m = useState(false), postRequested = _m[0], setRequestPostForm = _m[1];
    var handlePostMessage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var record, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoadingMode(true);
                    record = {
                        module: "SugarFeed",
                        name: replyMsg,
                        related_module: "SugarFeed",
                        assigned_user_id: (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes) === null || _a === void 0 ? void 0 : _a.id,
                        related_id: recordId,
                    };
                    return [4 /*yield*/, saveRecordMutation({
                            body: { module: "SugarFeed", record: record },
                        }).unwrap()];
                case 1:
                    result = _b.sent();
                    if (result) {
                        resetForm();
                        setLoadingMode(false);
                        setRequestPostForm(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        setReplyMessage("");
    };
    var showReplyForm = function () {
        setRequestPostForm(!postRequested);
    };
    var deleteRecordsMutation = useDeleteRecordsMutation()[0];
    var deleteSugarFeed = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingMode(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteRecordsMutation({
                            moduleName: record === null || record === void 0 ? void 0 : record.module_name,
                            body: { recordId: record === null || record === void 0 ? void 0 : record.id },
                        }).unwrap()];
                case 2:
                    result = _a.sent();
                    toast.success("Enregistrements supprimés");
                    setLoadingMode(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setLoadingMode(false);
                    toast.success("Une erreur est survenue lors de la suppression");
                    console.log("ERREUR DE SUPPRESSION ", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var _o = useState(false), isLoading = _o[0], setLoadingMode = _o[1];
    var _p = useState(false), isUserFeedRecord = _p[0], setIsUserFeedRecord = _p[1];
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex flex-row my-2" }, { children: [isLoading && _jsx(LoaderImage, {}), isUserFeedRecord ? (_jsx("div", __assign({ className: "text-sm w-5/6" }, { children: _jsxs("span", __assign({ className: "font-medium" }, { children: [activityAuthor, " ", _jsx("span", __assign({ className: "font-light" }, { children: record === null || record === void 0 ? void 0 : record.name }))] })) }))) : (_jsxs("div", __assign({ className: "text-sm w-5/6" }, { children: [_jsx("span", __assign({ className: "font-medium" }, { children: activityAuthor })), " a cr\u00E9\u00E9 un", _jsx("span", __assign({ className: "font-medium" }, { children: " nouveau" })), " ", activityName, " ", _jsx("span", __assign({ className: "text-blue-800 font-medium", onClick: goToDetail }, { children: objectName }))] }))), _jsxs("div", __assign({ className: "flex flex-row justify-end w-1/6" }, { children: [_jsx("span", __assign({ className: "px-1", onClick: showReplyForm }, { children: _jsx(FontAwesomeIcon, { icon: faCommentAlt, className: "text-blue-400 hover:hover:text-gray-400" }) })), _jsx("span", __assign({ onClick: deleteSugarFeed }, { children: _jsx(FontAwesomeIcon, { icon: faTrashCan, className: "text-red-400 hover:text-gray-400" }) }))] }))] })), _jsxs("div", __assign({ className: "" }, { children: [type === "Image" && linkUrl ? (_jsx("img", { className: "h-auto max-w-lg max-h-svh transition-all duration-300 rounded-lg cursor-pointer filter grayscale hover:grayscale-0", src: linkUrl })) : (_jsx("a", __assign({ className: "text-sm font-medium text-blue-800", href: linkUrl }, { children: linkUrl }))), _jsx(MessageDisplay, { parentId: recordId })] })), postRequested && (_jsxs("div", __assign({ className: "flex flex-row" }, { children: [_jsx("span", __assign({ className: "mr-2 mt-1 font-medium" }, { children: currentUser === null || currentUser === void 0 ? void 0 : currentUser.attributes.full_name })), _jsx("span", __assign({ className: "w-full mb-4 mr-2" }, { children: _jsx(Input, { type: "text", value: replyMsg, onChange: handleTextChange }) })), _jsx("button", __assign({ className: "w-1/5 mb-4 text-white end-2.5 bottom-2.5 bg-gray-400 hover:bg-gray-500 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-4 py-2 dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:ring-blue-800", onClick: handlePostMessage }, { children: "Poster" }))] })))] }));
};
